import { createApp } from 'vue';
import App from './App';
import SentryPlugin from '@lib/sentry-plugin';
import initWebLog from '@phenix/web-log';
import MixinRader from '@lib/mixin-radar';
import { radarConfig, defaultOpenConfig } from '@/config/config';
import LaunchApp from '@phenix/launch-app';
import Toast from '@/components/toast/index';

const app = createApp({
    mixins: [MixinRader],
    ...App,
});

app.config.globalProperties.$launchApp = new LaunchApp({
    ...defaultOpenConfig,
    fbUrl: defaultOpenConfig.fbUrl + '?ptfrom=testTimbreShare',
});
app.config.globalProperties.$weblog = initWebLog('WEB_GUANGYIN', {
    ...radarConfig,
});

app.use(SentryPlugin).use(Toast).mount('#app');
